import { render, staticRenderFns } from "./DataProcessor.vue?vue&type=template&id=0a3b263e&scoped=true"
import script from "./DataProcessor.vue?vue&type=script&lang=js"
export * from "./DataProcessor.vue?vue&type=script&lang=js"
import style0 from "./DataProcessor.vue?vue&type=style&index=0&id=0a3b263e&prod&lang=scss"
import style1 from "./DataProcessor.vue?vue&type=style&index=1&id=0a3b263e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3b263e",
  null
  
)

export default component.exports